import { S as Swiper } from './swiper-core-CZxReCTq.js';
import { N as Navigation } from './navigation-x_V9jDoE.js';
import { P as Pagination } from './pagination-Bm-_wMJZ.js';

class ProductMediaSwiper extends HTMLElement {
  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    new Swiper('.swiper--media', {
      modules: [Navigation, Pagination],
      spaceBetween: 16,
      slidesPerView: 1,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  }
}

customElements.define('product-media-swiper', ProductMediaSwiper);
